export default {"src":"/_next/static/media/unlock-features-dark.7d9abd9f.svg","height":100,"width":100};